export const IMAGE_UPLOAD_REQUESTED = 'image_upload_requested'
export const IMAGE_UPLOAD_SUCCEEDED = 'image_upload_succeeded'
export const IMAGE_UPLOAD_FAILED = 'image_upload_failed'
export const DELETE_IMAGE = 'delete_image'
export const SAVE_IMAGE_INFO = 'save_image_info'
export const IMAGE_CONVERT_REQUESTED = 'image_convert_requested'
export const IMAGE_CONVERT_SUCCEEDED = 'image_convert_succeeded'
export const IMAGE_CONVERT_FAILED = 'image_convert_failed'
export const SAVE_IMAGE_DATA = 'save_image_data'
export const SET_IMAGE_ERROR = 'set_image_error'
export const SET_SAMPLE_IMAGE = 'set_sample_image'
export const SET_IMAGE_SRC = 'set_image_src'
